const Joi = require("joi");

const dndSchema = (data, InviteThrough) => {
  const schema = Joi.object({
    ContactNumberOrEmail: Joi.alternatives().conditional("InviteThrough", {
      is: Joi.valid("0", "Mobile"), // Ensuring "0" and "Mobile" are treated as the same
      then: Joi.string()
        // .pattern(/^[0-9]{10}$/)
        .pattern(/^\(\d{3}\) \d{3}-\d{4}$/)
        .required()
        .messages({
          "any.required": "Please enter valid Mobile Number.",
          "string.pattern.base": "Please enter valid Mobile Number.",
          "string.empty": "Please enter Mobile Number.",
        }),
      // otherwise: Joi.string()
      //   .email({ tlds: { allow: false } })
      //   .required()
      //   .messages({
      //     "string.email": "Please enter valid E-mail.",
      //     "string.empty": "Please enter E-mail.",
      //   }),
      otherwise: Joi.string()
        // .pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
        // .pattern(/^(?!.*\.\.)[a-zA-Z0-9][a-zA-Z0-9._%+-]*[a-zA-Z0-9]@[a-zA-Z0-9.-]+\.(com|in|org|com\.in)$/)
        .pattern(
          // /^[a-zA-Z0-9]+(?:[._%+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*\.(com|in|org|com\.in)$/
          /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
        )
        
        

        .required()
        .messages({
          "any.required": "Please enter valid E-mail.",
          "string.pattern.base": "Please enter valid E-mail.",
          "string.empty": "Please enter E-mail.",
        }),
    }),

    InviteThrough: Joi.string()
      .valid("0", "1", "Mobile", "Email")
      .required()
      .messages({
        "any.only": "Please choose a method of invitation.",
        "string.empty": "Please choose a method of invitation.",
      }),

    Remarks: Joi.string().allow("").max(50).messages({
      "string.max": "Please enter Remarks with fewer than 50 characters.",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  }); 
};

module.exports = dndSchema;
